import AptitudeTestQuestion from 'src/entities/AptitudeTestQuestion';

export default class AptitudeTestSection {
  id: number;
  title: string;
  type: string;
  questions: Array<AptitudeTestQuestion>;

  constructor(entity: AptitudeTestSection) {
    this.id = entity.id;
    this.title = entity.title;
    this.type = entity.type;
    this.questions = entity.questions ?
      entity.questions.map(question => new AptitudeTestQuestion(question)) : [];
  }
}



// WEBPACK FOOTER //
// ./src/entities/AptitudeTestSection.tsx